import alcoholFreeIcon from 'assets/images/productPages/icon_alcohol_free.svg';
import crueltyFreeIcon from 'assets/images/productPages/icon_cruelty_free.svg';
import gmoFreeIcon from 'assets/images/productPages/icon_no_gmo.svg';
import parabenFreeIcon from 'assets/images/productPages/icon_paraben_free.svg';
import phtalateFreeIcon from 'assets/images/productPages/icon_phthalate_free.svg';
import sulfateFreeIcon from 'assets/images/productPages/icon_sulfate_free.svg';
import heroImgDesktop from 'assets/images/prose-assortment-of-haircare-and-skincare-products-science-desktop.jpg';
import heroImgMobile from 'assets/images/prose-assortment-of-haircare-and-skincare-products-science-mobile.jpg';
import ingredientGlossaryImg from 'assets/images/prose-product-ingredients-desktop.jpg';
import ingredientGlossaryImgMobile from 'assets/images/prose-product-ingredients-mobile.jpg';

const glossary = {
  hero: {
    title: (
      <>
        Naturally powerful and
        <br />
        proven effective
      </>
    ),
    subtitle:
      'Every ingredient is meticulously researched by our world-class R&D team and sustainably sourced from trusted partners around the globe. If it’s not high quality or highly efficacious, we won’t use it.',
    imageDesktop: heroImgDesktop,
    imageMobile: heroImgMobile,
    imageAlt: 'Prose assortment of custom haircare and skincare products',
  },
  innovativeApproach: {
    title: 'Leading with lab innovation',
    content:
      'Our in-house chemists endlessly test different combinations of high-performing natural and synthetic ingredients — for uniquely personalized formulas and always-improving results.',
    image: ingredientGlossaryImg,
    imageMob: ingredientGlossaryImgMobile,
    imageAlt: 'Prose customized shampoo bottle with lab bottles and oil dropper.',
  },
  cleanBeautyModule: {
    header: 'Everything you want (and nothing you don’t)',
    description:
      'Our formulas are cruelty-free with zero parabens, sulfates, phthalates, mineral oils, or GMOs. We can even make yours vegan, silicone-free, dye-free, or fragrance-free.',
    icons: [
      {
        alt: 'cruelty free logo',
        legend: 'cruelty free',
        src: crueltyFreeIcon,
      },
      {
        alt: 'sulfate free logo',
        legend: 'sulfate free',
        src: sulfateFreeIcon,
      },
      {
        alt: 'paraben free logo',
        legend: 'paraben free',
        src: parabenFreeIcon,
      },
      {
        alt: 'gmo free logo',
        legend: 'gmo free',
        src: gmoFreeIcon,
      },
      {
        alt: 'phthalate free logo',
        legend: 'phthalate free',
        src: phtalateFreeIcon,
      },
      {
        alt: 'alcohol free logo',
        legend: 'alcohol free',
        src: alcoholFreeIcon,
      },
    ],
  },
  completeList: {
    title: 'Our Ingredient Index',
    description: (
      <>
        Here’s what we’re working with. Every Prose formula is a unique combination chosen from
        these safe and sustainable ingredients. We’ve also included the EWG scores of
        each&mdash;we’re proud that the vast majority come in at 1. Just like in golf, we’re always
        going for a lower score here.
      </>
    ),
  },
  neverFoundIngredientsList: {
    title: 'The Never List',
    intro:
      'Healthy skin and hair starts with high quality ingredients — which means we have a long list of no-gos. You’ll never find any of these ingredients in our products, ever.',
    categoryTitle: 'HAIRCARE & SKINCARE',
    data: [
      ['Sulfates'],
      ['GMOs'],
      ['Alcohol (Ethanol)'],
      ['Phthalates'],
      ['Mineral Oil'],
      ['Petrolatum'],
      ['Parabens'],
      ['Formaldehyde'],
      ['Imidazolidinyl Urea '],
      ['Methylisothiazolinone (MIT)'],
      ['Methylchloroisot-hiazolinone (MCIT)'],
      ['Triclosan'],
      ['Triclocarban'],
      ['Butylhydroxyanisole'],
      ['Sulfites'],
      ['EDTA'],
      ['Ethanolamines'],
      ['Cocamide MEA'],
      ['Cocamide DEA'],
      ['Nanoparticules'],
      ['Talc'],
      ['Titamium Dioxide'],
      ['Benzophenone'],
      ['Ethylhexylmethoxy-cinnamate'],
      ['Dairy Derivatives'],
      ['Lanolin'],
      ['Methoxyethanol'],
      ['Phenoxyethanol'],
      ['Butoxyethanol'],
      ['Benzalkylmonium'],
      ['Chloride'],
      ['Quaternium-15'],
      ['BHT'],
    ],
  },
};

export default glossary;
